// For variant swatch functionality
function qAtcVariantOnchange(inp,desktop = true){
  let wrapper = null;
  let container = null;
  let option1 = null;
  let option2 = null;
  let option3 = null;
  let m_inp = '';

  if(desktop){//If desktop variant swatch
    wrapper = $(inp).parents('.q-atc-desk-variant-wrapper');
    container = $(wrapper).parents('.q-atc-desk-container');
  }else{//If mobile variant swatch
    wrapper = $(inp).parents('.q-atc-mob-variant-option-container');
    container = $(wrapper).parents('.q-atc-mob-content');
    m_inp = 'm-';
  }
  let options_count = parseInt($(wrapper).attr('data-options-count'));
  let product_id = parseInt($(wrapper).attr('data-product-id'));
  let cart_btn = $(container).find('.q-atc-btn');
  let product_data = window.q_atc_products[product_id];
  option1 = $(wrapper).find(`input[name="option-${m_inp}${product_id}-1"]:checked`).val() || null;
  option2 = $(wrapper).find(`input[name="option-${m_inp}${product_id}-2"]:checked`).val() || null;
  option3 = $(wrapper).find(`input[name="option-${m_inp}${product_id}-3"]:checked`).val() || null;
  variant = false;

  // Matching variant with values
  for(let i = 0;i < product_data['variants'].length;i++){
    const v = product_data['variants'][i];
    if(v['option1'] === option1 && v['option2'] === option2 && v['option3'] === option3){
      variant = v;
      break;
    }
  }

  // Selected Variant
  if(variant){
    // Set variant id
    $(cart_btn).attr('data-selected-variant',variant['id']);
    // Check availability
    if(variant['available'] === true){
      $(cart_btn).text('Add To Cart');
      $(cart_btn).prop('disabled', false);
    }else{
      $(cart_btn).text('Sold Out');
      $(cart_btn).prop('disabled', true);
    }

    // Price change for mobile
    if(desktop == false){
      let variant_price = paisaToInr(variant['price']);
      let variant_compare_at_price = (variant['compare_at_price']) ? paisaToInr(variant['compare_at_price']) : '';
      $(container).find('.q-atc-mob-price').text(variant_price);
      $(container).find('.q-atc-mob-compare-at-price s').text(variant_compare_at_price);
    }
  }
}

// For add to cart the product (Desktop)
function qAtcProductAddToCart(btn){
  let variant_id = parseInt($(btn).attr('data-selected-variant'));
  let quantity = 1;
  let c = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  let sections = c.getSectionsToRender().map((section) => section.id)

  // Disable Btn
  $(btn).text('Adding . . .');
  $(btn).prop('disabled',true);

  // Adding To Cart
  let formData = {
   'items': [{
    'id': variant_id,
    'quantity': quantity
    }],
    'sections' : sections
  };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(res => res.json())
  .then(cart => {
    // handleFloCartBtn();
    // Enable Btn
    $(btn).text('Add To Cart');
    $(btn).prop('disabled',false);

    // Open cart drawer
    cart['items'][0]['sections'] = cart['sections'];
    c.renderContents(cart['items'][0]);
    if (c && c.classList.contains('is-empty')) c.classList.remove('is-empty');

    // For close the mobile quick add to cart popup
    if(window.matchMedia("(max-width: 1024px)").matches){
      qAtcMobCloseModel();
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
  
}

// For open the mobile quick add to cart model
function qAtcMobOpenModel(product_id = null){
  if(!product_id) return;
  let overlay = document.querySelector('.q-atc-mob-model-overlay');
  let model = document.querySelector('.q-atc-mob-model-wrapper');
  let product_data = window.q_atc_products[product_id];
  let product_options = window.q_atc_product_options[product_id];

  // Update Product Image
  let image_src = product_data['featured_image'] || null;
  let image = (image_src) ? `<img src="${image_src}" class="q-atc-mob-product-image"/>` : '';
  $(model).find('.q-atc-mob-product-image-wrapper').html(image);
  //Product Image End

  // Update Product Info
  let info_html = `
    <h5 class="q-atc-mob-product-title">${product_data['title']}</h5>
    <div class="q-atc-mob-product-price-wrapper">
      <span class="q-atc-mob-compare-at-price"><s>${(product_data['compare_at_price']) ? paisaToInr(product_data['compare_at_price']) : ''}</s></span>
      <span class="q-atc-mob-price">${paisaToInr(product_data['price'])}</span>
    </div>
  `;
  $(model).find('.q-atc-mob-product-i-wrapper').html(info_html);
  //Product Info End

  // Update Product Options
  let options_html = '';
  if(product_options != 'default'){
    let options_length = product_options.length;
    options_html += `
      <div 
        class="q-atc-mob-variant-option-container" 
        data-options-count="${options_length}"
        data-product-id="${product_id}"
      >
    `;
    
    // Options Loop
    for(let i = 0;i < product_options.length;i++){
      options_html += `
        <div
          class="q-atc-mob-variant-option" 
          data-option-name="${product_options[i]['name']}" 
          data-option-position="${product_options[i]['position']}"
        >
      `;
      
      // Option title
      options_html += `<h3 class="q-atc-mob-option-title">${product_options[i]['name']}</h3>`;

      // Option Values
      options_html += `<div class="q-atc-mob-option-values-wrapper">`;
      for(let j = 0;j < product_options[i]['values'].length;j++){
        let color_img = document.querySelector(`.q-atc-desk-label img[data-option-name="${product_options[i]['name']}"][data-product-id="${product_id}"][data-option-value="${product_options[i]['values'][j]}"]`);
        let c_image = false;
        if(color_img){
          c_image = `
            <img 
              src="${color_img.src}" 
              data-option-name="${product_options[i]['name']}"
              data-product-id="${product_id}"
              data-option-value="${product_options[i]['values'][j]}"
              alt="${product_options[i]['name']}"
              width="100"
              height="100"
            />
          `;
        }
        
        let id = `option-m-${product_id}-${product_options[i]['name'].toLowerCase().replace(' ','_')}-${product_options[i]['values'][j].toLowerCase().replace(' ','_')}`;
        options_html += `
         <input 
            style="display:none;"
            onchange="qAtcVariantOnchange(this,false)"
            type="radio" 
            class="q-atc-mob-input"
            data-option-position="${product_options[i]['position']}"
            value="${product_options[i]['values'][j]}"
            data-option-name="${product_options[i]['name']}" 
            id="${id}"
            name="option-m-${product_id}-${product_options[i]['position']}"
            ${(product_options[i]['name'] != 'Size' && product_options[i]['name'] != 'size' && j == 0) ? 'checked' : ''}
          />
          <label 
            class="q-atc-mob-label"
            for="${id}"
            data-option-name="${product_options[i]['name'].toLowerCase()}"
            data-option-image="${(color_img) ? true : false}"
          >
            ${(color_img) ? c_image : product_options[i]['values'][j]}
          </label>
        `;
      }
      
      options_html += '</div>';
      
      
      options_html += '</div>';
    }
    options_html += '</div>';
  }
  $(model).find('.q-atc-mob-product-variants-wrapper').html(options_html);
  // Product Options End

  // Update Add To Cart Button
  if(product_options == 'default'){//If default product
    
    if(product_data['variants'][0]['available'] === true){
      $(model).find('.q-atc-btn').prop('disabled',false);
      $(model).find('.q-atc-btn').text('Add To Cart');
    }else{
      $(model).find('.q-atc-btn').prop('disabled',true);
      $(model).find('.q-atc-btn').text('Sold Out');
    }
    $(model).find('.q-atc-btn').attr('data-default-product','true');
    $(model).find('.q-atc-btn').attr('data-selected-variant',product_data['variants'][0]['id']);
    
  }else{//Variant Product

    $(model).find('.q-atc-btn').prop('disabled',true);
    $(model).find('.q-atc-btn').text('Add To Cart');
    $(model).find('.q-atc-btn').attr('data-default-product','false');
    $(model).find('.q-atc-btn').attr('data-selected-variant','');
    
  }
  // Add To Cart Button End
  
  // display the model
  $(overlay).addClass('active');
  $(model).addClass('active');
}

// For hide the model
function qAtcMobCloseModel(){
  let overlay = document.querySelector('.q-atc-mob-model-overlay');
  let model = document.querySelector('.q-atc-mob-model-wrapper');
  $(model).addClass('close').removeClass('active');
  setTimeout(() => {
    $(model).removeClass('close');
    $(overlay).removeClass('active');
  }, 400);
}

// For convert paisa to inr
function paisaToInr(paisa = 0){
    let inr = Math.round(paisa/100);
    inr += '';
    let x = inr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return 'Rs.' + x1 + x2;
}


$('.variant-selector-plus .plus-icon-area').click(function(){
  
  if($('.q-atc-desk-wrapper').hasClass('active')){
    $('.q-atc-desk-wrapper').removeClass('active');
     let selectedProductId = $(this).attr('q-atc-data-id');
     $(`[data-product-id="${ selectedProductId }"]`).addClass('active'); 
  }else{
      let selectedProductId = $(this).attr('q-atc-data-id');
      $(`[data-product-id="${ selectedProductId }"]`).addClass('active'); 
  }
})

$('.q-atc-close-btn').click(function(){ 
  $(this).parent().removeClass('active')  
})
